module.exports = __webpack_public_path__ + "img/html-evolution-8.4748744c.webp";